import { render, staticRenderFns } from "./FAQComponent.vue?vue&type=template&id=3cb24695&scoped=true"
import script from "./FAQComponent.vue?vue&type=script&lang=ts"
export * from "./FAQComponent.vue?vue&type=script&lang=ts"
import style0 from "./FAQComponent.vue?vue&type=style&index=0&id=3cb24695&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb24695",
  null
  
)

export default component.exports